import { UnderWritingQuestionState } from "./types";

export const defaultState = (): UnderWritingQuestionState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    underWritingQuestions: [],
    links: {}
  };
};

export const state = defaultState();
